import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { BeforeAfter } from './components/BeforeAfter';
import { Results } from './components/Results';
import { Recognize } from './components/Recognize';
import { Volumes } from './components/Volumes';
import { Included } from './components/Included';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="23ujha3i1d6za">
      <MetaPixel data-id="element-1" data-mp="3ikqz80j1f669" />
      <Hero data-id="element-2" data-mp="3ij65ue8glt9z" />
      <main data-id="element-3" data-mp="3ijpbavgxap74">
        <Story data-id="element-4" data-mp="3ihv0wb3a2fha" />
        <BeforeAfter data-id="element-5" data-mp="3mlj8gtrwtb2j" />
        <Results data-id="element-6" data-mp="3ml17xky7saot" />
        <Recognize data-id="element-7" data-mp="3mkhou0wtvg97" />
        <Volumes data-id="element-8" data-mp="3mjq1fdddwou0" />
        <Included data-id="element-9" data-mp="3mj6ibtbzzuee" />
        <Bonuses data-id="element-10" data-mp="3rcj5s04xxv5k" />
        <Offer data-id="element-11" data-mp="3rbzmog3k10py" />
        <Guarantee data-id="element-12" data-mp="3rdatypw7kqlt" />
        <Testimonials data-id="element-13" data-mp="3rd1azm9kzjpm" />
        <Author data-id="element-14" data-mp="3relw6la09qat" />
        <Faq data-id="element-15" data-mp="5orh0l86u6j" />
        <FinalCta data-id="element-16" data-mp="67znpl2q47d" />
      </main>
      <Footer data-id="element-17" data-mp="5ggje8nxyxz" />
      <FloatingCta data-id="element-18" data-mp="82ld64660ci" />
      <PurchasePopup data-id="element-19" data-mp="2zl3azit8d249" />
    </div>;
}